import { DataBean } from "../DataBean";

export class MassMail extends DataBean {

  
    public async uploadDestinatario(idMassEmail:number,data:any,attach:any): Promise<any> {
        return this.getCustomService("CacheOptions", "com.advantage.shared.Report_uploadDestinatario_Number_String_String", 
            [idMassEmail,data,attach]);
    }
    public async uploadDestinatarioAtach(idMassEmail:number,urlAtach:any): Promise<any> {
        return this.getCustomService("CacheOptions", "com.advantage.shared.Report_uploadDestinatarioAtach_Number_String", 
            [idMassEmail,urlAtach]);
    }
    public async sendMassMail(idMassEmail:number,subject:string): Promise<any> {
        return this.getCustomService("CacheOptions", "Number_sendMassMail_Number_String", 
            [idMassEmail,subject]);
    }
    public async sendMassMailItem(idMassEmail:number,idMassMailItem:number,subject:string): Promise<any> {
        return this.getCustomService("CacheOptions", "Number_sendMassMailItem_Number_Number_String", 
            [idMassEmail,idMassMailItem,subject]);
    }
  
   
}
